<template>
  <section
    class="component-aaeec3b4"
    resmed-component-name="50/50_icon-line_list_text"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-md-11 col-lg-10">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>

            <div class="row mt-5">
              <div class="col-md-6">
                <div
                  class="list-items"
                  v-bind:style="{
                    'background-color':
                      acf.layout['list-items-background-color'],
                  }"
                >
                  <h4>{{ acf["content-list-introduction"] }}</h4>
                  <ul>
                    <li
                      v-for="content in acf['content-list']"
                      v-html="content.item"
                    ></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6">
                <div class="p-2 pt-4 p-md-3">
                  <p v-html="acf['content-paragraphs']"></p>
                </div>
              </div>
            </div>

            <!-- <a v-if="acf.cta.href" v-bind:href="acf.cta.href" v-bind:target="acf.cta.target" class="btn cta-pill filled-red icon right-arrow mt-5">{{ acf.cta.text }}</a> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-aaeec3b4", // 50/50_icon-line_list_text
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-aaeec3b4 {
  background-size: cover;
  background-repeat: no-repeat;
  padding: 6rem 0 5rem 0;
}

.component {
  h2 {
    position: relative;
    text-align: center;
    margin: 0;

    @extend %eyebrow-center;
  }

  h4 {
    color: $cc-resmed-white;
    margin-bottom: 2rem;
  }

  .list-items {
    background-color: $cc-resmed-hero-blue;
    border-radius: 6px;
    padding: 2rem 2.5rem;
  }

  ul {
    max-width: 920px;
    padding: 0 0 0 1.25rem;
    margin: 0 auto;

    li {
      position: relative;
      color: $cc-resmed-white;
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
      padding-left: 0.5rem;
      @extend %body-normal-bold;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: -1rem;
        width: 100%;
        height: 1px;
        background-color: rgba($cc-resmed-grey-30, 0.325);
      }

      &:last-child {
        margin: 0;
        padding: 0 0 0 0.5rem;

        &:after {
          display: none;
        }
      }
    }
  }

  .cta {
    > a {
      margin: 0 0.5rem;
    }
  }
}
</style>